import React, { useMemo } from 'react';
import loadable from '@loadable/component';
import { Spin } from 'antd';
import styled from 'styled-components';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CM_BASE_ROUTE } from '../pages/constants/cmConstants';
import { cmResources } from '../util/GlobalConstant';
import { hasResource } from '../util';

const StyledSpin = styled(Spin)`
  width: 100%;
  margin: 200px 0;
`;

const CMApp = loadable(
  () =>
    import(
      /* webpackChunkName: "cm" */
      '../pages/cm/CMApp'
    ),
  {
    fallback: <StyledSpin delay={500} />
  }
);

const CMRoutes = ({ authentication }) => {
  const hasAccess = useMemo(
    () =>
      hasResource(
        authentication?.data,
        cmResources.APP_7_RESOURCE_UI_CM_GENERIC
      ),
    [authentication]
  );

  return hasAccess ? (
    <>
      <Route exact path="/app" render={() => <Redirect to={CM_BASE_ROUTE} />} />
      <Route path={CM_BASE_ROUTE} component={CMApp} />
    </>
  ) : null;
};

CMRoutes.propTypes = {
  authentication: PropTypes.object
};

export default CMRoutes;
